import { Trans, useTranslation } from 'react-i18next';

import Spinner from '@/components/Spinner';
import { usePlans } from '@/hooks/price';
import CheckCircle from '@/icons/check-circle.svg';
import { formatPrice, recurringDetailsText } from '@/utils/money';

function PlanCard({ plan }) {
	const { t } = useTranslation();

	const functions = t(`unsubscribe.${plan.name}.functions`, {
		returnObjects: true
	});
	return (
		<div className="flex flex-1 flex-col items-start justify-start rounded border bg-white md:w-full">
			<div className="flex w-full flex-1 flex-grow-0 flex-col gap-2 border-b border-grey-200 px-6 py-7">
				<h2 className="font-semibold leading-7">
					{t(`plans.${plan.name}.name`)}
				</h2>
				<h3 className="font-title text-3xl font-normal leading-10">
					{`${formatPrice({
						amount: plan.baseAmount,
						currency: plan.currency
					})} ${recurringDetailsText(plan)}`}
				</h3>
				<span className="text-xs font-semibold leading-5 text-grey-500">
					{t(`unsubscribe.${plan.name}.periodicity`)}
				</span>
				<p className="text-xs leading-5 text-grey-500">
					{t(`unsubscribe.${plan.name}.description`)}
				</p>
			</div>
			<div className="flex w-full flex-1 flex-grow flex-col gap-4 px-6 py-7">
				<h2 className="text-sm font-semibold leading-6">
					{t(`unsubscribe.${plan.name}.including`)}
				</h2>
				<div className="flex flex-col gap-3">
					{functions.map((func, index) => {
						return (
							<div className="flex items-center gap-2" key={index}>
								<CheckCircle />
								<p className="text-xs leading-5">
									<Trans
										i18nKey={func}
										components={{
											strong: <strong className="font-semibold" />
										}}
									/>
								</p>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}

function Payment() {
	const { t } = useTranslation();
	const { plans, loading } = usePlans();

	return (
		<div className="z-10 flex flex-col gap-10">
			<div className="container flex flex-col items-center gap-5 text-center">
				<h3 className="whitespace-break-spaces font-title text-[32px] font-semibold leading-10 -tracking-[1px] lg:text-[40px] lg:font-bold lg:leading-[52px]">
					{t('unsubscribe.payment.title')}
				</h3>
				<p className="lg:max-w-[814px]">
					{t('unsubscribe.payment.subtitle')}
				</p>
			</div>
			<div className="flex flex-col gap-5 lg:flex-row">
				{loading && (
					<Spinner
						className="absolute inset-0 m-auto text-grey-500"
						size={24}
					/>
				)}
				{plans.map(plan => {
					return <PlanCard key={plan.handlerId} plan={plan} />;
				})}
			</div>
		</div>
	);
}

export default Payment;
